<template>
  <v-container pt-0>
    <FactsHeader />
    <TopListBreweries />
  </v-container>
</template>
<script>
import FactsHeader from './../components/facts/FactsHeader'
import TopListBreweries from './../components/facts/TopListBreweries'

export default {
  components: {FactsHeader, TopListBreweries}
}
</script>
